function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate cutPipeBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const alertResult = async (title, message) => {
    const alertSource = {
      type: 'alertBehavior',
      title,
      message,
      options: [{
        title: 'OK',
        actions: []
      }]
    };
    await evaluateSource(alertSource, content, parentContentPath, transientContext, nativeFunctions);
  };
  const info = await evaluateSource(source.info, content, parentContentPath, transientContext, nativeFunctions);
  if (info === undefined) {
    await alertResult('Error', 'Misconfiguration.');
    return;
  }
  const {
    oldPipe = {},
    newPipe = {},
    currentLength = 0
  } = info;
  const {
    parts = {},
    bends = {}
  } = content;
  const {
    length: newLength = 0
  } = newPipe;
  const oldLength = currentLength - newLength;
  const makeContent = pipe => {
    const {
      barcodes,
      bends: bendSelections = {},
      stage
    } = pipe;
    const fullBends = Object.keys(bendSelections).reduce((acc, key) => {
      acc[key] = bends[key];
      return acc;
    }, {});
    return {
      barcodes,
      bends: fullBends,
      parts,
      stage
    };
  };
  const oldContent = makeContent(oldPipe);
  const newContent = _objectSpread(_objectSpread({}, content), makeContent(newPipe));
  newContent.identifier = newPipe.identifier;
  newContent.currentLength = newLength;
  newContent.title = `Pipe: ${newPipe.identifier}`;
  newContent.parentPipeIdentifier = oldPipe.identifier;
  oldContent.currentLength = oldLength;
  const addBehavior = {
    type: 'addFormBehavior',
    formTypeIdentifier: 'pipe',
    initialContent: newContent
  };
  const newFormID = await evaluateSource(addBehavior, content, parentContentPath, transientContext, nativeFunctions);
  if (newFormID === undefined) {
    await alertResult('Error', 'Unable to create new pipe.');
    return;
  }
  const clear = {
    barcodes: null,
    parts: null,
    bends: null,
    stage: null
  };
  const patchBehavior = {
    type: 'patchContentBehavior',
    patches: [clear, oldContent]
  };
  const patchedContent = await evaluateSource(patchBehavior, content, parentContentPath, transientContext, nativeFunctions);
  if (patchedContent === undefined) {
    await alertResult('Error', 'Unable to update old pipe.');
    return;
  }
  await alertResult('Success', 'New pipe created and original pipe updated.');
};
module.exports = {
  evaluate
};